import { render, staticRenderFns } from "./TheProjectRoyaltiesChart.vue?vue&type=template&id=4e1d6f40&"
import script from "./TheProjectRoyaltiesChart.vue?vue&type=script&lang=js&"
export * from "./TheProjectRoyaltiesChart.vue?vue&type=script&lang=js&"
import style0 from "./TheProjectRoyaltiesChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports